
export  {images}

const images = 
   [
    {
      alt: 'Description de l\'image 1',
      src: './assets/imgEtale/etale1.webp',
      title: 'Titre de l\'image 1'
    },
    {
      alt: 'Description de l\'image 2',
      src: './assets/imgEtale/etale2.webp',
      title: 'Titre de l\'image 2'
    },
    {
      alt: 'Description de l\'image 3',
      src: './assets/imgEtale/etale3.webp',
      title: 'Titre de l\'image 3'
    },
    {
      alt: 'Description de l\'image 4',
      src: './assets/imgEtale/etale4.webp',
      title: 'Titre de l\'image 4'
    },
    {
      alt: 'Description de l\'image 5',
      src: './assets/imgEtale/etale5.webp',
      title: 'Titre de l\'image 5'
    },
    {
      alt: 'Description de l\'image 6',
      src: './assets/imgEtale/etale6.webp',
      title: 'Titre de l\'image 6'
    },
    {
      alt: 'Description de l\'image 7',
      src: './assets/imgEtale/etale7.webp',
      title: 'Titre de l\'image 7'
    },
    {
      alt: 'Description de l\'image 8',
      src: './assets/imgEtale/etale8.webp',
      title: 'Titre de l\'image 8'
    },
    {
      alt: 'Description de l\'image 9',
      src: './assets/imgEtale/etale9.webp',
      title: 'Titre de l\'image 9'
    },
    {
      alt: 'Description de l\'image 10',
      src: './assets/imgEtale/etale10.webp',
      title: 'Titre de l\'image 10'
    },
    {
      alt: 'Description de l\'image 11',
      src: './assets/imgEtale/etale11.webp',
      title: 'Titre de l\'image 11'
    },
    {
      alt: 'Description de l\'image 12',
      src: './assets/imgEtale/etale12.webp',
      title: 'Titre de l\'image 12'
    },
    {
      alt: 'Description de l\'image 13',
      src: './assets/imgEtale/etale13.webp',
      title: 'Titre de l\'image 13'
    },
    {
      alt: 'Description de l\'image 14',
      src: './assets/imgEtale/etale1.webp',
      title: 'Titre de l\'image 14'
    },
    // ... Ajoutez d'autres objets d'image avec leurs propriétés
  ];
  export default images;